"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FS = void 0;
const nodeFS = __importStar(require("fs"));
const nodePath = __importStar(require("path"));
const glob = __importStar(require("glob"));
const fs_extra_1 = __importDefault(require("fs-extra"));
const del = __importStar(require("del"));
exports.FS = {
    /**
     * 获取目标根路径
     * @returns 返回路径字符串
     */
    processRoot() {
        return process.cwd();
    },
    /**
     * 拼接路径
     * @param paths 路径名称
     * @returns 返回拼接后的路径字符串
     */
    join(...paths) {
        return nodePath.join(...paths);
    },
    /**
     * 获取绝对路径
     * @param paths 路径名称
     * @returns 返回绝对路径字符串
     */
    resolve(...paths) {
        return nodePath.resolve(...paths);
    },
    /**
     * 获取相对路径
     * @param rootpath 根路径
     * @param pathNames 目标路径名称
     * @returns 返回相对路径字符串
     */
    relative(rootpath, pathNames) {
        return nodePath.relative(rootpath, pathNames);
    },
    /**
     * 验证路径是否为绝对路径
     * @param filePath 文件路径
     * @returns 是否为绝对路径
     */
    isAbsolutePath(filePath) {
        return nodePath.isAbsolute(filePath);
    },
    /**
     * 验证路径是否存在
     * @param path 路径名称
     * @returns 是否存在
     */
    hasPath(path) {
        return nodeFS.existsSync(path);
    },
    /**
     * 获取文件名（基本名）
     * @param filePath 文件路径
     * @param ext 后缀名
     * @returns 文件名字符串
     */
    baseName(filePath, ext) {
        return nodePath.basename(filePath, ext);
    },
    /**
     * 通过分隔符拆分文件路径并获取指定部分
     * @param filePath 文件路径
     * @param splitStr 用于拆分文件路径的分隔符
     * @returns 拆分后的字符串
     */
    splitFileName(filePath, splitStr) {
        return filePath.split(splitStr)[1];
    },
    /**
     * 获取 Windows 或 Linux 系统的路径分隔符
     * @returns 路径分隔符字符串
     */
    getSlash() {
        if (process.platform === 'win32') {
            return '\\';
        }
        else {
            return '/';
        }
    },
    /**
     * 根据匹配模式获取所有文件
     * @param pattern 匹配模式字符串
     * @returns 文件路径数组
     */
    getFiles(pattern) {
        let files = [];
        let resource = glob.sync(pattern, { dot: true });
        resource.forEach((item) => {
            if (nodeFS.statSync(item).isFile()) {
                files.push(item);
            }
        });
        return files;
    },
    /**
     * 批量删除不同目录下的文件（不能删除文件夹）
     * @param files 包含文件路径的数组
     * @param fn 错误回调函数
     */
    deleteFiles(files, fn) {
        files.forEach(file => {
            nodeFS.unlink(file, err => {
                if (err && fn) {
                    fn(err);
                }
            });
        });
    },
    /**
     * 删除文件夹及其内部文件
     * @param folder 文件夹路径名称
     * @param sync 是否需要同步执行
     */
    deleteFolder(folder, sync) {
        if (sync) {
            del.deleteSync(folder, { force: true });
        }
        else {
            del.deleteAsync(folder, { force: true });
        }
    },
    /**
     * 复制文件
     * @param path 源文件路径
     * @param targetPath 目标文件路径
     * @param opt 复制选项或过滤函数
     */
    copyFile(path, targetPath, opt) {
        if (opt) {
            fs_extra_1.default.copySync(path, targetPath, opt);
        }
        else {
            fs_extra_1.default.copySync(path, targetPath);
        }
    },
    /**
     * 创建文件夹
     * @param dir 路径名称
     */
    createFloder(dir) {
        fs_extra_1.default.ensureDirSync(dir);
    },
    /**
     * 创建空文件
     * @param filePath 文件路径名称
     * @param fn 回调函数
     */
    createFile(filePath, fn) {
        fs_extra_1.default.ensureFileSync(filePath);
        if (fn) {
            fn(filePath);
        }
    },
    /**
     * 从文件中读取内容
     * @param filePath 文件路径
     * @param isJSON 是否解析为 JSON
     * @returns 字符串或 JSON 对象
     */
    readFile(filePath, isJSON) {
        let content;
        let data = nodeFS.readFileSync(filePath, {
            encoding: 'utf-8',
        });
        if (isJSON) {
            if (data.length === 0) {
                return {};
            }
            content = JSON.parse(data);
        }
        else {
            if (data.length === 0) {
                return '';
            }
            content = data;
        }
        return content;
    },
    /**
     * 将内容写入文件
     * @param filePath 文件路径
     * @param fileContent 字符串或 JSON 内容
     * @param isJSON 是否为 JSON 格式
     */
    writeFile(filePath, fileContent, isJSON) {
        let data = isJSON ? JSON.stringify(fileContent, null, 2) : fileContent;
        nodeFS.writeFileSync(filePath, data, {
            encoding: 'utf-8',
        });
    },
};
exports.default = exports.FS;
